/**
 * The meeting report ("Výpis pro poradu", CZNA-553) is a reviewer's tool (CZNA-1510).
 *
 * <p>The permission of the endpoint the report reads, not a role predicate: mod-czna-users
 * grants it only to a cataloguing supervisor — a library's or NK's — and to the authority
 * admin (`CapabilitySyncService#REVIEWER_ONLY_PATHS`). Until CZNA-1510 the button gated on
 * `records.review-queue.get`, which every user holds, so cataloguers saw it too.
 * `hasPerm` is UX only — the sidecar answers 403 either way.
 */
export var MEETING_REPORT_CAPABILITY = 'czna-authorities.proposals.pending-report.get';
